import React from "react";
import PageHeader from "../components/PageHeader";
import PublicPageSettings from "../components/PublicPageSettings";
import ListingsManager from "../components/ListingsManager";

export default function PropertySearchHome() {
  return (
    <div>
      <PageHeader
        title="Properties"
        subtitle="Edit page settings and browse property listings. Click any listing to view its full details."
      />

      <PublicPageSettings
        collectionKey="property-search"
        publicPath="/property-search"
        defaultHeading="Properties for Sale and Lease"
        defaultSubheading="Find properties for sale across all major property types — office, industrial, retail, and data centers."
      />

      <ListingsManager />
    </div>
  );
}
